import { BACKLOG_LOAD_FAILURE, BACKLOG_LOAD_START, BACKLOG_LOAD_SUCCESS, BACKLOG_EDIT_COMPLETION_DATE_FAILURE, BACKLOG_EDIT_COMPLETION_DATE_SUCCESS, BACKLOG_EDIT_REMARK_SUCCESS, BACKLOG_GENERAL_EDIT_SUCCESS, BACKLOG_GENERAL_EDIT_FAILURE, BACKLOG_SAMPLE_STATUS_FILTER_CHANGE, BACKLOG_SAMPLE_STATUS_FILTER_START, BACKLOG_SAMPLE_STATUS_FILTER_COMPLETE, BACKLOG_EDIT_APPROVAL_STATUS_SUCCESS } from "./backlog.types";
import { PO_DATA_LOADER_PROGRESS, PO_EDIT_DATA_FAILURE, PO_EDIT_DATA_SUCCESS, PO_LOAD_FAILURE, PO_LOAD_START, PO_LOAD_SUCCESS, PO_SINGLE_UPLOAD_SUCCESS } from "./po.types";

export const init_po_backlog_state = {
  po: {
  },
  backlog: {
    sample_types: [],
  },
  notifications: []
};

export const po_backlog_reducer = (state = init_po_backlog_state, action) => {
  const { type, payload } = action;
  switch (type) {
    case BACKLOG_LOAD_START: {
      // console.log("upload started");
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              loading: true,
              success: false,
              failure: false,
              error_message: null
            }
          }
        }
      };
      return temp;
    }
    case BACKLOG_LOAD_FAILURE: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              failure: true,
              error_message: payload,
              success: false,
              loading: false
            }
          }
        }
      };
      return temp;
    }
    case BACKLOG_LOAD_SUCCESS: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          ...payload
        },
      };
      return temp;
    }
    case BACKLOG_EDIT_COMPLETION_DATE_FAILURE: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              failure: true,
              error_message: payload,
              success: false,
              loading: false
            }
          }
        }
      };
      return temp;
    }
    case BACKLOG_EDIT_COMPLETION_DATE_SUCCESS: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            ...payload,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              success: true,
              failure: false,
              loading: false,
              error_message: null
            }
          }
        },
      };
      return temp;
    }
    case BACKLOG_EDIT_REMARK_SUCCESS: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            ...payload,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              success: true,
              failure: false,
              loading: false,
              error_message: null
            }
          }
        },
      };
      return temp;
    }
    case BACKLOG_GENERAL_EDIT_FAILURE: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              failure: true,
              error_message: payload,
              success: false,
              loading: false
            }
          }
        }
      };
      return temp;
    }
    case BACKLOG_GENERAL_EDIT_SUCCESS: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            ...payload,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              success: true,
              failure: false,
              loading: false,
              error_message: null
            }
          }
        },
      };
      return temp;
    }
    case BACKLOG_SAMPLE_STATUS_FILTER_START: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              success: false,
              failure: false,
              loading: true,
              error_message: null
            }
          },
        },
      };
      return temp;
    }
    case BACKLOG_SAMPLE_STATUS_FILTER_CHANGE: {
      console.log("change", payload);
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            ...payload,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              success: true,
              failure: false,
              loading: true,
              error_message: null
            }
          },
        },
      };
      return temp;
    }
    case BACKLOG_SAMPLE_STATUS_FILTER_COMPLETE: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              success: true,
              failure: false,
              loading: false,
              error_message: null
            }
          },
        },
      };
      return temp;
    }
    case BACKLOG_EDIT_APPROVAL_STATUS_SUCCESS: {
      const temp = {
        ...state,
        backlog: {
          ...state.backlog,
          intm: {
            ...state.backlog.intm,
            ...payload,
            intermediate_states: {
              ...state.backlog.intm.intermediate_states,
              success: true,
              failure: false,
              loading: false,
              error_message: null
            }
          },
        },
      };
      return temp;
    }
    case PO_LOAD_START: {
      // console.log("upload started");
      const temp = {
        ...state,
        po: {
          ...state.po,
        }
      };
      return temp;
    }
    case PO_LOAD_FAILURE: {
      console.log("failed to load po", payload);
      const temp = {
        ...state,
        po: {
          ...state.po,
        }
      };
      return temp;
    }
    case PO_LOAD_SUCCESS: {
      console.log({ success: payload });
      const temp = {
        ...state,
        po: {
          ...state.po,
          ...payload,
        },
      };
      return temp;
    }
    case PO_EDIT_DATA_SUCCESS: {
      const temp = {
        ...state,
        po: {
          ...state.po,
          ...payload,
          intermediate_states: {
            ...state.po.intermediate_states,
            success: true,
            failure: false,
            loading: false,
            error_message: null
          }
        },
      };
      return temp;
    }
    case PO_EDIT_DATA_FAILURE: {
      const temp = {
        ...state,
        po: {
          ...state.po,
          intermediate_states: {
            ...state.po.intermediate_states,
            success: false,
            failure: true,
            loading: false,
            error_message: payload
          }
        },
      };
      return temp;
    }
    case PO_SINGLE_UPLOAD_SUCCESS: {
      const temp = {
        ...state,
        po: {
          ...state.po,
          upload_progress: {
            ...state.po.upload_progress,
            ...payload
          }
        }
      };
      return temp;
    }
    case PO_DATA_LOADER_PROGRESS: {
      const temp = {
        ...state,
        po: {
          ...state.po,
          download_progress: {
            ...state.po.download_progress,
            ...payload
          }
        }
      };
      return temp;
    }
    default:
      return state;
  }
};